import { useState, useEffect } from "react";
import { API_URLS, BEARER_TOKENS } from "./config";
import { useLanguage } from "LanguageContext";
import axios from "axios";

export interface ChangeLogItem {
  id: number;
  position: number;
  title: string;
  badge: string;
}

export interface ChangeLogDate {
  id: number;
  title: string;
  position: number;
  items_change_logs: ChangeLogItem[];
}

export interface ChangeLogData {
  pageTitle: string;
  paragraph: any;
  subtitle1: string;
  subtitle2: string;
  dates_about: ChangeLogDate[];
}

export function useChangeLogService() {
  const [changeLogData, setChangeLogData] = useState<ChangeLogData | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const lang = useLanguage();
  const domain = window.location.hostname;

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setLoading(true);

        const response = await axios.get(API_URLS.ABOUT, {
          params: {
          filters: {
            frontend_types: {
              hostname: {
                $eq: domain,
              },
            },
          },
          populate: {
             date_abouts: {
               populate: "*",
            },
            frontend_types: {
              populate: ['logo'], // populate only the logo field
            },
          },
          locale: lang.language,
          }
        });

        // check response
        if (response.status != 200) {
          throw new Error("Failed to fetch Changelog data");
        }

        const json = response.data;
        const data: ChangeLogData = {
          pageTitle: json.data[0]?.page_title || "",
          subtitle1: json.data[0]?.subtitle1 || "",
          paragraph: json.data[0]?.paragraph || "",
          subtitle2: json.data[0]?.subtitle2 || "",

          dates_about: json.data[0]?.date_abouts
            ? json.data[0].date_abouts.map(
                (date: any): ChangeLogDate => ({
                  id: date.id,
                  title: date.title,
                  position: date.position,
                  items_change_logs: date.items_change_logs
                    ? date.items_change_logs.map(
                        (item: any): ChangeLogItem => ({
                          id: item.id,
                          position: item.position,
                          title: item.title,
                          badge: item.badge,
                        })
                      )
                    : [],
                })
              )
            : [],
        };

        setChangeLogData(data);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, [lang.language]);

  return { changeLogData, loading, error };
}
